var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M15 7c-.739 0-1.431.2-2.025.55A4 4 0 1 0 6.2 10.857 4.995 4.995 0 0 0 4 15v4a1 1 0 1 0 2 0v-4a3 3 0 1 1 6 0v4a1 1 0 1 0 2 0v-4H16.429c.867 0 1.571.704 1.571 1.571V19a1 1 0 1 0 2 0v-2.429a3.57 3.57 0 0 0-1.837-3.122A4 4 0 0 0 15 7zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-6-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" })
  );
});